import { useState } from 'react';
import { X, ZoomIn, ZoomOut } from 'lucide-react';

const ImageViewer = ({ url, alt, primaryColor }) => {
  const [expanded, setExpanded] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const toggleExpand = () => {
    setExpanded(!expanded);
  };

  const handleImageLoad = () => {
    setLoading(false);
  };

  const handleImageError = (e) => {
    console.error('Erro ao carregar imagem:', e);
    setError(true);
    setLoading(false);
  };

  // Estilo para o modal de visualização expandida
  const modalStyle = {
    display: expanded ? 'flex' : 'none',
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.85)',
    zIndex: 1000,
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  };

  if (error) {
    return (
      <div className="mt-3 mb-1 rounded-lg bg-red-50 p-3 text-red-600 flex items-center">
        <div className="w-5 h-5 mr-2 text-red-600">❌</div>
        <span className="text-sm">Não foi possível carregar a imagem.</span>
      </div>
    );
  }

  return (
    <div className="mt-3 mb-1">
      {/* Visualização em miniatura */}
      <div 
        className="rounded-lg overflow-hidden cursor-pointer relative"
        onClick={toggleExpand}
      >
        {loading && (
          <div className="bg-gray-100 rounded-lg w-full aspect-video flex items-center justify-center">
            <div className="w-6 h-6 border-2 border-t-transparent rounded-full animate-spin"
                style={{ borderColor: `${primaryColor || '#4a6cf7'} transparent transparent transparent` }}
            />
          </div>
        )}
        
        <img 
          src={url} 
          alt={alt || "Imagem gerada"} 
          className={`w-full rounded-lg transition-opacity duration-300 ${loading ? 'opacity-0' : 'opacity-100'}`}
          onLoad={handleImageLoad}
          onError={handleImageError}
        />
        
        <div className="absolute bottom-2 right-2 bg-black bg-opacity-50 rounded-full p-1 text-white flex items-center justify-center">
          <ZoomIn className="w-4 h-4" />
        </div>
      </div>
      
      {/* Modal de visualização expandida */}
      <div style={modalStyle} onClick={toggleExpand}>
        <div className="relative max-w-4xl max-h-[90vh]">
          <img 
            src={url} 
            alt={alt || "Imagem expandida"} 
            className="max-w-full max-h-[90vh] object-contain rounded"
          />
          
          <button 
            className="absolute top-2 right-2 bg-black bg-opacity-50 rounded-full p-2 text-white"
            onClick={(e) => {
              e.stopPropagation();
              setExpanded(false);
            }}
          >
            <X className="w-5 h-5" />
          </button>
          
          <button 
            className="absolute bottom-2 left-2 bg-black bg-opacity-50 rounded-full p-2 text-white"
            onClick={toggleExpand}
          >
            <ZoomOut className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageViewer;